<template>
  <div class="localEncry-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      :rules="editRules"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="公钥" prop="pub_key">
            <el-input v-model="formDate.pub_key" placeholder="请输入公钥"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="余额" prop="text">
            <el-input v-model="formDate.text" placeholder="请输入明文"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="加密余额">
            <el-input
              v-model="proclaimedTextEncryption"
              class="excellent-form-input readonly-text"
              readonly=""
              type="textarea"
              autosize=""
              disabled
            ></el-input>
            <el-button v-if="isChangeText" class="excellent-form-btn" @click.prevent="changeText()"
              >隐藏</el-button
            >
            <el-button v-if="!isChangeText" class="excellent-form-btn" @click.prevent="changeText()"
              >显示</el-button
            >
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="localEncryption()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      formDate: {
        pub_key: '',
        text: '',
        user_id: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID)
      },
      isChangeText: false,
      proclaimedTextDecryption: '', //显示文本
      proclaimedText: '', //后台返回后文本
      proclaimedTextEncryption: '', //加密
      editRules: {
        pub_key: [{ required: true, message: '请输入公钥', trigger: 'blur' }],
        text: [
          { required: true, message: '请输入明文', trigger: 'blur' },
          { pattern: /^\d+$/, message: '请输入非负整数', trigger: 'blur' }
        ]
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {},
  methods: {
    localEncryption() {
      this.$refs.formDate.validate().then(valid => {
        if (valid) {
          this.$apis.encryption.encrypt(this.formDate).then(res => {
            if (res) {
              this.proclaimedTextEncryption = '********'
              this.proclaimedText = res.data
              this.$message.success('成功!')
            }
          })
        }
      })
    },
    changeText() {
      this.isChangeText = !this.isChangeText

      this.isChangeText
        ? (this.proclaimedTextEncryption = this.proclaimedText)
        : (this.proclaimedTextEncryption = '********')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

.localEncry-wrapper {
  @include adaptation(
    (
      --common-gap-16: 16px
    )
  );
  /deep/ .el-form-item__content {
    display: flex;

    :not(:first-child) {
      margin-left: var(--common-gap-16);
    }
  }

  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}
</style>
